export default __webpack_public_path__ + "static/media/plus.918332e2.svg";